<script lang="ts">
	import './questions.component.css';
	import { _ } from '../../../../utility-services/Translation.service';

	let showDropdown = $state(false);
	let timeoutId: ReturnType<typeof setTimeout> | null = null;
	let questionsContainer: HTMLElement = $state();
	let dropdownElement: HTMLElement = $state();

	function showTooltip() {
		if (timeoutId) {
			clearTimeout(timeoutId);
			timeoutId = null;
		}
		showDropdown = true;
	}

	function isInsideQuestionsDropdown(target: EventTarget | null): boolean {
		if (!(target instanceof Node)) {
			return false;
		}

		return Boolean(questionsContainer?.contains(target) || dropdownElement?.contains(target));
	}

	function hideTooltip(event?: MouseEvent | FocusEvent) {
		if (isInsideQuestionsDropdown(event?.relatedTarget ?? null)) {
			return;
		}

		timeoutId = setTimeout(() => {
			showDropdown = false;
		}, 300);
	}
</script>

<div
	bind:this={questionsContainer}
	class="vtmn-relative vtmn-flex vtmn-items-center vtmn-justify-center questions-container"
	role="navigation"
	onmouseenter={showTooltip}
	onmouseleave={hideTooltip}
	onfocus={showTooltip}
	onblur={hideTooltip}
>
	<span
		class="vtmx-customer-service-line vtmn-text-4xl"
		role="button"
		tabindex="0"
		aria-label="Menu d'aide"
	></span>
	{#if showDropdown}
		<div
			bind:this={dropdownElement}
			class="vtmn-dropdown vtmn-absolute vtmn-rounded vtmn-whitespace-nowrap vtmn-mt-1 dropdown-positioned"
			role="menu"
			tabindex="-1"
			onmouseenter={showTooltip}
			onmouseleave={hideTooltip}
		>
			<div class="vtmn-dropdown_items vtmn-flex vtmn-flex-col vtmn-w-full dropdownItems">
				<div class="vtmn-p-2 vtmn-w-full help">
					<span class="vtmn-text-center">{$_('need_help')}</span>
				</div>
				<a
					href="https://support.decathlon.net/saw/ess/offeringPage/89825232"
					target="_blank"
					rel="noopener noreferrer"
					class="dropdown-link vtmn-block vtmn-no-underline"
				>
					<div class="vtmn-p-2">
						<span>{$_('contact_support')}</span>
					</div>
				</a>
				<a
					href="https://sites.google.com/decathlon.com/g-co/accueil?authuser=0"
					target="_blank"
					rel="noopener noreferrer"
					class="dropdown-link vtmn-block vtmn-no-underline"
				>
					<div class="vtmn-p-2">
						<span>{$_('find_dct_site')}</span>
					</div>
				</a>
			</div>
		</div>
	{/if}
</div>
